import React, { useEffect, useState } from 'react';
import { TimePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';

interface CustomTimeRangePickerProps {
    value?: [Dayjs | null, Dayjs | null];
    onChange?: (value: [Dayjs | null, Dayjs | null]) => void;
    format?: string;
    use12Hours?: boolean;
    style?: React.CSSProperties;
    startPlaceholder?: string;
    endPlaceholder?: string;
}

const CustomTimeRangePicker: React.FC<CustomTimeRangePickerProps> = ({
    value,
    onChange,
    format = 'hh:mm A',
    use12Hours = true,
    style = {},
    startPlaceholder = 'Start Time',
    endPlaceholder = 'End Time',
}) => {
    console.log('value', value)
    const [startTime, setStartTime] = useState<Dayjs | null>(null)
    const [endTime, setEndTime] = useState<Dayjs | null>(null)

    useEffect(() => {
        if (startTime && endTime && onChange) {
            onChange([startTime, endTime])
        }
    }, [startTime, endTime])

    useEffect(() => {
        if (value) {
            if (value[0]) {
                setStartTime(value[0])
            }
            if (value[1]) {
                setEndTime(value[1])
            }
        }

    }
        , [value])

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, ...style }}>
            <TimePicker
                value={startTime}
                onChange={(val) => setStartTime(val ? dayjs(val.valueOf()) : null)}
                format={format}
                use12Hours={use12Hours}
                placeholder={startPlaceholder}
                style={{ flex: 1 }}
            />
            <span>to</span>
            <TimePicker
                value={endTime as any}
                onChange={(val) => setEndTime(val ? dayjs(val.valueOf()) : null)}
                format={format}
                use12Hours={use12Hours}
                placeholder={endPlaceholder}
                style={{ flex: 1 }}
            />
        </div>
    );
};

export default CustomTimeRangePicker; 